import { useAppDispatch } from '@pkg/hooks';

import { apiFactory, Auth } from '@app/client';
import { setError } from '@app/store/actions/error';

export function usePassword() {
    const dispatch = useAppDispatch();

    async function resetPassword({ password, token }: { password: string; token: string }) {
        return apiFactory()
            .call(Auth.passwordReset, { value: { password, password_reset_token: token } })
            .then((r) => {
                if (!r.ok) {
                    dispatch(setError({ ...r, notify: true }));
                }
                return r;
            })
            .catch((e) => {
                dispatch(setError({ ...e, notify: true }));
                return e;
            });
    }

    async function sendPasswordResetEmail({ email }: { email: string }) {
        return apiFactory()
            .call(Auth.passwordResetEmail, { value: { email: email.trim() } })
            .then((r) => {
                if (!r.ok) {
                    dispatch(setError({ ...r, notify: true }));
                }
                return r;
            })
            .catch((e) => {
                dispatch(setError({ ...e, notify: true }));
                return e;
            });
    }

    return {
        resetPassword,
        sendPasswordResetEmail,
    };
}
